import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import { ValidationHelper } from '../helpers/ValidationHelper';
import { AppTheme } from '../styles/AppTheme';
import {
  StyleSheet,
  css
} from 'aphrodite';

export class TextInputComponent extends Component {

  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value
    }
  }

  change = e => {
    this.setState({ value: e.target.value });
    this.props.setValue(e.target.value, this.props.formField.key)
  }

  render() {
    return (
      <TextField
        id={this.props.formField.key}
        label={this.props.formField.label}
        className={css(Styles.inputCss)}
        value={this.state.value}
        onChange={e => this.change(e)}
        margin='normal'
        type={this.props.formField.inputHide ? 'password' : this.props.formField.type}
        helperText={!this.props.enableValidation ? '' : ValidationHelper.validateFields(this.props.formField, this.state.value)}
        disabled={this.props.disabled}
        FormHelperTextProps={{ classes: { root: css(Styles.errorMsgStyle) } }}
        InputProps={{
          disableUnderline: true,
          classes: {
            root: this.props.action === 'viewInfo' ?
              css(Styles.textFieldContentInput,Styles.textFieldContentInputView) : css(Styles.textFieldContentInput)
          }
        }}
        InputLabelProps={{
          classes: {
            root: css(Styles.textFieldContent),
            shrink: css(Styles.textFieldContentShrink),
          }
        }}
      />
    )
  }
}

const Styles = StyleSheet.create({
  inputCss: {
    margin: 8,
    flex: 1,
    color: AppTheme.white,
    minHeight: AppTheme.formFieldHeight
  },
  errorMsgStyle: {
    color: AppTheme.white,
    paddingLeft: 8
  },
  textFieldContentInput: {
    borderRadius: 4,
    backgroundColor: AppTheme.secondaryColor,
    paddingLeft: 8,
    color: AppTheme.white,
  },
  textFieldContentInputView: {
    backgroundColor: AppTheme.primaryBackground,
  },
  textFieldContent: {
    color: AppTheme.white,
    zIndex: 1,
    paddingLeft: 8,
    opacity: .6,
    '@media(max-width: 767px)': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      right: 22,
    }
  },
  textFieldContentShrink: {
    right: 'unset'
  }
})


// WEBPACK FOOTER //
// ./src/components/TextInputComponent.js